<template>
  <div class="content-wrapper">

    <slot />

    <navigation />
  </div>
</template>

<script>
import Navigation from './ContentWrapper/Navigation'

export default {
  components: {
    Navigation
  }
}
</script>

<style lang="scss">

@import '../assets/scss/breakpoint.scss';

.content-wrapper {
  position: relative;
  width: 100%;
  background-color: white;
  @include media(">=large"){
    width: 85%;
  }
  @include media(">=xlarge"){
    width: 75%;
  }
}

.content-wrapper img {
  width: 100%;
}

.content-wrapper .slider {
  width: 100%;
}
</style>
